module.exports = __webpack_public_path__ + "static/img/undraw_svg_4.e7c76c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/undraw_svg_4.svg
// module id = 0Hj/
// module chunks = 0